/**
 * BulkLoadFile API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BulkLoadItemDto { 
    id: string;
    /**
     * The date of the upload.
     */
    uploadDate: string;
    userId: string;
    fileName: string;
    /**
     * Number of records sent for massive load.
     */
    totalRegistries: number;
    errorCount?: number;
    status: BulkLoadItemDto.StatusEnum;
    /**
     * The user Name.
     */
    userName: string;
}
export namespace BulkLoadItemDto {
    export const StatusEnum = {
        Reading: 'READING',
        Processing: 'PROCESSING',
        Completed: 'COMPLETED',
        CompletedWithError: 'COMPLETED_WITH_ERROR',
        Error: 'ERROR'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


